import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
} from "firebase/firestore";

import { db, auth } from "../firebase/config";

import { updateDoc, arrayUnion } from "firebase/firestore";

export const assignMemberToTrainer = async (
  trainerId,
  memberId,
  trainerName,
) => {
  const uid = auth.currentUser?.uid;

  // Update trainer
  const trainerRef = doc(db, "gyms", uid, "trainers", trainerId);

  await updateDoc(trainerRef, {
    assignedMembers: arrayUnion(memberId),
  });

  // Update member
  const memberRef = doc(db, "gyms", uid, "members", memberId);

  await updateDoc(memberRef, {
    trainerId,
    trainerName,
  });
};

const getTrainerCollection = () => {
  const uid = auth.currentUser?.uid;

  if (!uid) {
    throw new Error("User not authenticated");
  }

  return collection(db, "gyms", uid, "trainers");
};

export const addTrainer = async (data) => {
  return await addDoc(getTrainerCollection(), data);
};

export const getTrainers = async () => {
  const snapshot = await getDocs(getTrainerCollection());

  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};

export const deleteTrainer = async (id) => {
  const uid = auth.currentUser?.uid;

  await deleteDoc(doc(db, "gyms", uid, "trainers", id));
};
